import { Box, Grid, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import useSWRMutation from "swr/mutation";

import { DotLoader } from "react-spinner-overlay";
import { blueGrey } from "@mui/material/colors";
import { fetcherPost } from "../../../../services/fetcher";
import { useAppDispatch } from "../../../../hooks/useRedux";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../redux/features/snackbarSlice";
import EmptyCargoSVG from "../../../../media/images/icons/empty-cargo";
import MobileHeader from "../../../layout/OwnerLayout/Header";
import DoneBolsCard from "./DoneBolsCard";
import CustomDatePicker from "../../../components/DatePicker";
import { useFormik } from "formik";

import CustomSelectOption from "../../../components/CustomSelectOption";
import { Day } from "react-modern-calendar-datepicker";
import { toGregorian } from "jalaali-js";
import { useInView } from "react-intersection-observer";
import { IBolItem } from "../../../../types/bolsHistories";

export default function ManageBillLadingPage() {
  const dispatch = useAppDispatch();

  const theme = useTheme();

  const [bolsList, setBolsList] = useState<IBolItem[]>([]);

  const [filterDate, setFilterDate] = useState<Day | null>();

  const [pageCounts, setPageCounts] = useState(0);

  const [pageN, setPageN] = useState(1);

  const { ref, inView } = useInView({
    /* Optional options */
    threshold: 0,
  });

  const formik = useFormik({
    initialValues: {
      pageNr: 1,
      shipStatus: 0,
      payStatus: 0,
    },
    onSubmit: (values) => {
      const newValues = {
        ...values,
        shipStatus: values.shipStatus || null,
        payStatus: values.payStatus || null,
      };

      getBolsGistories(newValues);
    },
  });

  const { trigger: getBolsGistories, isMutating: isgetBolsGistoriesMutting } =
    useSWRMutation(
      [`/Nobat/OwnerBolList`, localStorage.getItem("access_token")],
      fetcherPost,
      {
        onSuccess: (data) => {
          setBolsList(data.data);
          setPageCounts(data.count);
        },
      }
    );

  const {
    trigger: getBolsGistoriesNextPage,
    isMutating: isgetBolsGistoriesMuttingNextPage,
  } = useSWRMutation(
    [`/Nobat/OwnerBolList`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: (data) => {
        setBolsList([...bolsList, ...data.data]);
      },
    }
  );

  useEffect(() => {
    getBolsGistories({
      pageNr: 1,
    });
    //     {
    //   getActiveNobat: false,
    //   nobatStatus: 0,
    //   pageNr: 1,
    // }
  }, [getBolsGistories]);

  const handleChangeSelectOption = (value: any, type: string) => {
    console.log(type, value);

    setPageN(1);

    setBolsList([]);

    switch (type) {
      case "shipStatus":
        formik.setFieldValue("shipStatus", Number(value) || null);
        formik.handleSubmit();
        break;

      case "payStatus":
        formik.setFieldValue("payStatus", Number(value) || null);
        formik.handleSubmit();
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    if (inView && pageCounts > bolsList.length) {
      setPageN((prev) => prev + 1);
    }
  }, [inView]);

  useEffect(() => {
    getBolsGistoriesNextPage({
      pageNr: pageN,
      shipStatus: formik.values.shipStatus || null,
    });
  }, [pageN]);

  return (
    <>
      <MobileHeader
        title={
          <Typography
            sx={{
              fontWeight: 700,
              color: "secondary.main",
              fontSize: 16,
            }}
          >
            سوابق بارنامه
          </Typography>
        }
      />
      <Grid
        container
        spacing={1}
        sx={{
          width: "100%",
          paddingX: "8px",
        }}
      >
        <Grid item xs={4}>
          <CustomSelectOption
            type="shipStatus"
            setValue={handleChangeSelectOption}
            value={formik.values.shipStatus?.toString() || "0"}
            // error={companyActivity.error}
            // errorMessage={companyActivity.errorMessage}
            options={[
              {
                value: 0,
                label: "رسید کالا",
                disabled: true,
              },
              {
                value: 2,
                label: "رسید نشده",
              },
              {
                value: 5,
                label: "رسید شده",
              },
              {
                value: 0,
                label: "همه موارد",
              },
            ]}
          />
        </Grid>
        <Grid item xs={4}>
          <CustomSelectOption
            type="payStatus"
            setValue={handleChangeSelectOption}
            value={formik.values.payStatus?.toString() || "0"}
            // error={companyActivity.error}
            // errorMessage={companyActivity.errorMessage}
            options={[
              {
                value: 0,
                label: "پرداخت کرایه",
                disabled: true,
              },
              {
                value: 1,
                label: "پرداخت شده",
              },
              {
                value: 2,
                label: "پرداخت نشده",
              },
              {
                value: 0,
                label: "همه موارد",
              },
            ]}
          />
        </Grid>
        <Grid item xs={4}>
          <CustomDatePicker
            value={filterDate || null}
            handleResetDate={() => {
              formik.setFieldValue("bolDate", null);
              setFilterDate(null);

              formik.handleSubmit();
            }}
            // error={
            //   loadingDateFotmik.touched.loadingDate &&
            //   Boolean(loadingDateFotmik.errors.loadingDate)
            // }
            // errorMessage={
            //   loadingDateFotmik.touched.loadingDate &&
            //   loadingDateFotmik.errors.loadingDate
            // }
            onChange={(value) => {
              setPageN(1);
              setBolsList([]);
              if (value) {
                const { gd, gm, gy } = toGregorian(
                  value?.year,
                  value?.month,
                  value?.day
                );
                formik.setFieldValue(
                  "bolDate",
                  new Date(gy, gm - 1, gd + 1).toISOString()
                );
                setFilterDate(value);
              }
              formik.handleSubmit();
            }}
            label={"تاریخ بارنامه"}
          />
        </Grid>
      </Grid>

      {isgetBolsGistoriesMutting ? (
        <Box
          sx={{
            flex: "1",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              height: "200px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "16px",
            }}
          >
            <DotLoader color={theme.palette.primary.main} />
            <Typography>لطفا منتظر باشید...</Typography>
          </Box>
        </Box>
      ) : !bolsList.length ? (
        <Box
          sx={{
            flex: "1",
            display: "flex",
            flexDirection: "column",
            overflow: "auto",
            padding: "8px",
            gap: "8px",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              height: "200px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "16px",
            }}
          >
            <EmptyCargoSVG size={125} color={theme.palette.primary.main} />
            <Typography
              maxWidth={150}
              textAlign={"center"}
              sx={{
                fontWeight: "700",
                color: blueGrey[500],
              }}
            >
              در حال حاضر محموله تکمیل شده ندارید
            </Typography>
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: "8px",
            gap: "8px",
          }}
        >
          {bolsList.map((item, index) => (
            <>
              <DoneBolsCard
                ref={index + 1 === pageN * 10 ? ref : null}
                key={item.id}
                {...item}
              />
              {isgetBolsGistoriesMuttingNextPage &&
                index === bolsList.length - 1 && (
                  <Box
                    sx={{
                      minHeight: "200px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "16px",
                    }}
                  >
                    <DotLoader color={theme.palette.primary.main} />
                    <Typography>لطفا منتظر باشید...</Typography>
                  </Box>
                )}
            </>
          ))}
        </Box>
      )}
    </>
  );
}
